import { createGlobalStyle } from 'styled-components';

export interface DefaultThemeProps {
    foregroundColor?: string;
    backgroundColor?: string;
    headerBackgroundColor?: string;
    headerForegroundColor?: string;
    /** Full-page backdrop URL. When set it is painted behind header + body and the header background goes transparent. */
    backgroundImage?: string | null;
}

export const DEFAULT_THEME = {
    foregroundColor: '#000000',
    backgroundColor: '#FFFFFF',
    headerBackgroundColor: '#000000',
    headerForegroundColor: '#FFFFFF',
};

// CSS url() literal for the backdrop; strips characters that could terminate the literal.
const cssUrl = (url: string) => `url("${url.replace(/["\\\n\r]/g, '')}")`;

export default createGlobalStyle`
body {
    color: ${({ foregroundColor }: DefaultThemeProps) =>
        foregroundColor || DEFAULT_THEME.foregroundColor};
    background-color: ${({ backgroundColor }: DefaultThemeProps) =>
        backgroundColor || DEFAULT_THEME.backgroundColor};
}

/* Fixed, full-viewport backdrop. A pseudo-element rather than
   background-attachment: fixed so it stays put on iOS and on pages where the
   body itself scrolls. Sits between the canvas (background-color) and content. */
${({ backgroundImage }: DefaultThemeProps) =>
    backgroundImage
        ? `
body::before {
    content: '';
    position: fixed;
    inset: 0;
    z-index: -1;
    background-image: ${cssUrl(backgroundImage)};
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    pointer-events: none;
}
`
        : ''}

.Fullscreen-modal,
.Share-container {
    color: ${({ headerForegroundColor }: DefaultThemeProps) =>
        headerForegroundColor || DEFAULT_THEME.headerForegroundColor};
    background-color: ${({ headerBackgroundColor }: DefaultThemeProps) =>
        headerBackgroundColor || DEFAULT_THEME.headerBackgroundColor};

}

.Share-form input {
    color: ${({ headerForegroundColor }: DefaultThemeProps) =>
        headerForegroundColor || DEFAULT_THEME.headerForegroundColor};
    background-color: ${({ headerBackgroundColor }: DefaultThemeProps) =>
        headerBackgroundColor || DEFAULT_THEME.headerBackgroundColor};
    border-color: ${({ headerForegroundColor }: DefaultThemeProps) =>
        headerForegroundColor || DEFAULT_THEME.headerForegroundColor};
    border-style:solid;
    font-family: 'Roboto', sans-serif;
}

.Share-form .Link-button {
    background-color: ${({ headerBackgroundColor }: DefaultThemeProps) =>
        headerBackgroundColor || DEFAULT_THEME.headerBackgroundColor};
    color: ${({ headerForegroundColor }: DefaultThemeProps) =>
        headerForegroundColor || DEFAULT_THEME.headerForegroundColor};
}

.SB-Modal {
    color: ${({ headerForegroundColor }: DefaultThemeProps) =>
        headerForegroundColor || DEFAULT_THEME.headerForegroundColor};
    background-color: ${({ headerBackgroundColor }: DefaultThemeProps) =>
        headerBackgroundColor || DEFAULT_THEME.headerBackgroundColor};
}

.Gallery-cell.expanded {
color: ${({ foregroundColor }: DefaultThemeProps) =>
    foregroundColor || DEFAULT_THEME.foregroundColor};
    background-color: ${({ backgroundColor }: DefaultThemeProps) =>
        backgroundColor || DEFAULT_THEME.backgroundColor};
}

.AbsoluteGallery-cell.expanded {
color: ${({ foregroundColor }: DefaultThemeProps) =>
    foregroundColor || DEFAULT_THEME.foregroundColor};
    background-color: ${({ backgroundColor }: DefaultThemeProps) =>
        backgroundColor || DEFAULT_THEME.backgroundColor};
}

.Gallery-cell.expanded > .options {
color: ${({ foregroundColor }: DefaultThemeProps) =>
    foregroundColor || DEFAULT_THEME.foregroundColor};
    background-color: ${({ backgroundColor }: DefaultThemeProps) =>
        backgroundColor || DEFAULT_THEME.backgroundColor};;
}

.AbsoluteGallery-cell.expanded > .options {
color: ${({ foregroundColor }: DefaultThemeProps) =>
    foregroundColor || DEFAULT_THEME.foregroundColor};
    background-color: ${({ backgroundColor }: DefaultThemeProps) =>
        backgroundColor || DEFAULT_THEME.backgroundColor};;
}

.cta-button {
    color: ${({ headerForegroundColor }: DefaultThemeProps) =>
        headerForegroundColor || DEFAULT_THEME.headerForegroundColor};
    background-color: ${({ headerBackgroundColor }: DefaultThemeProps) =>
        headerBackgroundColor || DEFAULT_THEME.headerBackgroundColor};
    border-color: ${({ headerForegroundColor }: DefaultThemeProps) =>
        headerForegroundColor || DEFAULT_THEME.headerForegroundColor};
    border-style:solid;
    }

.Gallery-header {
    background-color: ${({ headerBackgroundColor, backgroundImage }: DefaultThemeProps) =>
        backgroundImage
            ? 'transparent'
            : headerBackgroundColor || DEFAULT_THEME.headerBackgroundColor};
    color: ${({ headerForegroundColor }: DefaultThemeProps) =>
        headerForegroundColor || DEFAULT_THEME.headerForegroundColor};
}

.Button-primary {
    background-color: ${({ headerBackgroundColor }: DefaultThemeProps) =>
        headerBackgroundColor || DEFAULT_THEME.headerBackgroundColor};
    color: ${({ headerForegroundColor }: DefaultThemeProps) =>
        headerForegroundColor || DEFAULT_THEME.headerForegroundColor};
}

.Button-tertiary {
    background-color: ${({ headerBackgroundColor }: DefaultThemeProps) =>
        headerBackgroundColor || DEFAULT_THEME.headerBackgroundColor};
    color: ${({ headerForegroundColor }: DefaultThemeProps) =>
        headerForegroundColor || DEFAULT_THEME.headerForegroundColor};
}

.Gallery-name {
    color: ${({ headerForegroundColor }: DefaultThemeProps) =>
        headerForegroundColor || DEFAULT_THEME.headerForegroundColor};
}

.Loading-wrapper:first-child {
    background-color: ${({ backgroundColor }: DefaultThemeProps) =>
        backgroundColor || DEFAULT_THEME.backgroundColor};
    color: ${({ foregroundColor }: DefaultThemeProps) =>
        foregroundColor || DEFAULT_THEME.foregroundColor};  
}


.cta-container {
    background-color: ${({ backgroundColor }: DefaultThemeProps) =>
        backgroundColor || DEFAULT_THEME.foregroundColor};
    }

.Find-your-own-photos-banner {
    background-color: ${({ headerBackgroundColor }: DefaultThemeProps) =>
        headerBackgroundColor || DEFAULT_THEME.headerBackgroundColor};
    color: ${({ headerForegroundColor }: DefaultThemeProps) =>
        headerForegroundColor || DEFAULT_THEME.headerForegroundColor};
}

.Media-container {
    background-color: ${({ backgroundColor }: DefaultThemeProps) =>
        backgroundColor || DEFAULT_THEME.backgroundColor}; 
}

.video-js {
    background-color: ${({ backgroundColor }: DefaultThemeProps) =>
        backgroundColor || DEFAULT_THEME.backgroundColor} !important; 
}

.qr-code > path:first-child {
    stroke: ${({ headerForegroundColor }: DefaultThemeProps) =>
        headerForegroundColor || DEFAULT_THEME.headerForegroundColor};
}

.qr-code {
    border-color: ${({ headerForegroundColor }: DefaultThemeProps) =>
        headerForegroundColor || DEFAULT_THEME.headerForegroundColor};
    border-style:solid;
    border-width: 6px;

}

.cover-bg {
    background-color: ${({ backgroundColor }: DefaultThemeProps) =>
        backgroundColor || DEFAULT_THEME.backgroundColor};
}

.Base-text {
    color: ${({ foregroundColor }: DefaultThemeProps) =>
        foregroundColor || DEFAULT_THEME.foregroundColor};
}

.Base-text-secondary {
    color: ${({ foregroundColor }: DefaultThemeProps) =>
        foregroundColor || DEFAULT_THEME.foregroundColor};
    opacity: 0.7;
}



`;
